import * as React from 'react';
import { createSubcomponent } from '@workday/canvas-kit-react/common';
import { ModalOverlay } from './ModalOverlay';
import styled from '@emotion/styled';
import { useModalModel } from './hooks';
const StyledOverlay = styled(ModalOverlay)({
    '& > div': { maxHeight: 'inherit' }, // reset maxHeight of centering div
});
export const ModalOverflowOverlay = createSubcomponent('div')({
    displayName: 'Modal.OverflowOverlay',
    modelHook: useModalModel,
})((elemProps, Element) => {
    return React.createElement(StyledOverlay, Object.assign({ as: Element, overflowX: "hidden", overflowY: "auto" }, elemProps));
});
